var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBublespeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Buble_speech",
    "data-name": "Buble speech",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.961,
    height: 16,
    viewBox: "0 0 14.961 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M12.6.137,10.657,1.231l-.209.113-.066.036c-.087.046-.176.094-.26.142a7.457,7.457,0,0,0-2.644-.479c-.24,0-.482.011-.718.034a7.479,7.479,0,1,0,8.2,7.444,7.4,7.4,0,0,0-1.569-4.585c.027-.092.051-.185.079-.288.009-.031.017-.063.025-.094s.016-.058.024-.087l.592-2.155a1.03,1.03,0,0,0-.173-.9A1.053,1.053,0,0,0,13.112,0,1.037,1.037,0,0,0,12.6.137Zm-2.028,2.3c.09-.054.2-.115.314-.172l.007,0c.08-.042.174-.093.264-.143L13.1,1.025l.012-.006a.038.038,0,0,1,.016.013l0,0s0,0,0,.009L12.537,3.2c-.013.048-.026.1-.039.147l-.012.044c-.03.115-.062.234-.094.336l-.134.427.279.349a6.445,6.445,0,0,1,1.344,4.919,6.287,6.287,0,0,1-1.139,2.86,6.455,6.455,0,0,1-5.264,2.7,6.773,6.773,0,0,1-.81-.05A6.312,6.312,0,0,1,3.7,13.761,6.465,6.465,0,0,1,1.134,7.282a6.185,6.185,0,0,1,.936-2.3A6.657,6.657,0,0,1,4.434,2.821a6.5,6.5,0,0,1,5.4-.32l.385.151Z",
    transform: "translate(14.961 16) rotate(180)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBublespeech);
export default __webpack_public_path__ + "static/media/Buble speech.e6e747cf9b320fa36dc66ecbd8e52300.svg";
export { ForwardRef as ReactComponent };